<template>
  <div>
    <v-divider class="my-4" />
    <div class="d-flex flex-wrap mb-5">
      <div class="info-wrap">
        <div class="info-wrap-status">
          <div class="info-wrap-status-box lightSuccess"></div>
          <div class="info-wrap-status-txt">
            {{ $t("stillageStatus.empty") }}
          </div>
        </div>
      </div>
      <div class="info-wrap">
        <div class="info-wrap-status">
          <div class="info-wrap-status-box warning"></div>
          <div class="info-wrap-status-txt">
            {{ $t("stillageStatus.hasSpace") }}
          </div>
        </div>
      </div>
      <div class="info-wrap">
        <div class="info-wrap-status">
          <div class="info-wrap-status-box error"></div>
          <div class="info-wrap-status-txt">
            {{ $t("stillageStatus.full") }}
          </div>
        </div>
      </div>
    </div>
    <div class="warehouse-reference-wrapper">
      <div class="d-flex">
        <div
          ref="wrapper"
          :style="{
            overflow: 'auto',
            maxHeight: $vuetify.breakpoint.height - 310 + 'px',
            maxWidth: '100%',
            width: '100%',
          }"
        >
          <!-- +=+=+=+=++=+=+=+=+ |column numeration| +=+=+=+=++=+=+=+=+ -->
          <div
            class="warehouse-view-table-navigation warehouse-view-table-navigation-horizontal"
          >
            <WarehouseBox
              :key="`letter-${letterIndex}`"
              class="text-uppercase"
              :class="['warehouse-index-top-box']"
              :width="columnWidth"
              v-for="(columnWidth, letterIndex) in data.columns"
              >{{ getLetter(letterIndex) }}
            </WarehouseBox>
          </div>
          <!--column numeration-->

          <div class="d-flex">
            <!-- +=+=+=+=++=+=+=+=+ |row numeration| +=+=+=+=++=+=+=+=+ -->
            <div
              class="warehouse-view-table-navigation warehouse-view-table-navigation-vertical"
            >
              <WarehouseBox
                :height="rowHeight"
                :class="['warehouse-index-left-box']"
                :key="`row-${rowIndex}`"
                v-for="(rowHeight, rowIndex) in data.rows"
                >{{ rowIndex + 1 }}
              </WarehouseBox>
            </div>
            <!--row numeration-->
            <div class="d-flex text-uppercase table-cell-wrapper">
              <!-- +=+=+=+=++=+=+=+=+ |columns start| +=+=+=+=++=+=+=+=+ -->
              <div
                v-for="(column, columnIndex) in data.boards"
                :key="columnIndex"
              >
                <!--
                  @contextmenu.prevent="-->
                <!--                    onClickContextMenu({ event: $event, item: row })-->
                <!--                  "
                                    --
                                  >-->
                <WarehouseStillageBox
                  :width="row.width"
                  :height="row.height"
                  :selected="!!selectedCellsItem[row.id]"
                  @click="boxClickHandler(row, $event)"
                  :key="`row-${rowIndex}-${columnIndex}`"
                  v-for="(row, rowIndex) in column"
                  :item="row"
                  :class="trueSet(row.alarm) ? 'show_animation_alarm' : ''"
                >
                  {{ getLetter(columnIndex) }}{{ rowIndex + 1 }}
                </WarehouseStillageBox>
              </div>
              <!-- columns end-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <ContextMenu
      @closed="onClosedContextMenu"
      v-model="contextMenuOptions.isVisible"
      :position="contextMenuOptions.position"
    >
      <!--      <v-btn :to="{name: 'product-income-create',-->
      <!--      params: {warehouseId: $route.params.id, cellId: $route.params.cellId},-->
      <!--      query: {carriages:selectedCells}-->
      <!--      }" color="primary">{{ $t('income') }}-->
      <!--      </v-btn>-->
      <div class="py-1">
        <VBtn
          width="100%"
          v-if="canIncomeAction"
          @click="openDialog"
          color="primary"
        >
          {{ $t("income") }}
        </VBtn>
      </div>
      <div class="py-1">
        <VBtn width="100%" @click="openSettingsDialog" color="primary">
          {{ $t("settings") }}
        </VBtn>
      </div>
      <div class="py-1">
        <VBtn width="100%" @click="openWarehouseFileDialog" color="primary">
          {{ $t("addWithFile") }}
        </VBtn>
      </div>
    </ContextMenu>

    <VDialog v-model="settingsDialog" width="400">
      <VCard>
        <VCardTitle>{{ warehouseName }}</VCardTitle>
        <VCardText>
          <div class="d-flex align-center flex-wrap ma-n2">
            <div
              :key="`setting-cell-${index}`"
              class="pa-2"
              v-for="(item, index) in selectedCells"
            >
              <span class="mr-2 d-inline-block">{{ $t("hasPlace") }}</span>
              <VSwitch
                hide-details
                false-value="true"
                :label="item.name"
                class="ma-0"
                true-value="false"
                v-model="selectedCells[index].full"
              ></VSwitch>
            </div>
          </div>
          <div class="text-right">
            <VBtn @click="saveSettings" color="primary">{{ $t("save") }}</VBtn>
          </div>
        </VCardText>
      </VCard>
    </VDialog>

    <WarehouseFileDialog ref="warehouseFileDialogRef"></WarehouseFileDialog>

    <DraggableDialog
      v-click-outside="closeProductItemInfoDialog"
      ref="draggableDialog"
      :initial-position="{ top: item.top, left: item.left }"
      @onClosed="
        () => {
          closeDialog(index);
          closeProductItemInfoDialog();
        }
      "
      :key="`draggable-dialog-${index}`"
      v-for="(item, index) in productItems"
      v-model="item.dialog"
    >
      <VCard elevation="2" width="500" style="cursor: move">
        <VCardTitle>{{ item.name }} </VCardTitle>
        <VCardText>
          <div class="mb-3">
            <div v-if="item.products.length">
              <InfiniteScroll
                style="overflow: auto; max-height: 350px"
                @next="getNextPageProducts"
              >
                <ProductListInWarehouse :products="item.products" />
                <template #loading>
                  <span>{{
                    contextMenuOptions.lastPage > contextMenuOptions.page
                      ? $t("loading")
                      : ""
                  }}</span>
                </template>
              </InfiniteScroll>
            </div>
            <div class="font-weight-bold mt-1" v-else>
              {{ $t("noPlacementProduct") }}
            </div>
          </div>
        </VCardText>
      </VCard>
    </DraggableDialog>
    <WarehouseViewDialog
      @saved="$emit('update')"
      ref="openDialogStillage"
      @CloseWarehouseViewDialog="CloseWarehouseViewDialog"
    />
  </div>
</template>

<script>
import { getLetter } from "@/utils/numeration";
import "./warehouse.css";
import "./warehouse-edit-table.css";
import { makerPagination, trueSet } from "@/utils/pureFunctions";
import WarehouseStillageBox from "@/components/warehouse/StillageBox";
import DraggableDialog from "@/components/ui/draggable-dialog/DraggableDialog";
import ProductListInWarehouse from "@/components/product/ProductListInWarehouse";
import ContextMenu from "@/components/ui/context-menu/ContextMenu";
import WarehouseViewDialog from "@/components/warehose-view-dialog/WarehouseViewDialog";
import InfiniteScroll from "@/components/ui/infinite-scroll/InfiniteScroll";
import WarehouseBox from "@/components/warehouse/WarehouseBox.vue";
import WarehouseFileDialog from "@/components/omtk/WarehouseFileDialog.vue";

const DEFAULT_CONTEXT_MENU_OPTIONS = {
  isVisible: false,
  page: 0,
  carriageId: null,
  lastPage: 0,
  position: {
    top: 150,
    left: 150,
  },
};

export default {
  name: "stillage-view",
  data() {
    return {
      settingsDialog: false,
      nameFilterProduct: null,
      contextMenuOptions: {
        ...DEFAULT_CONTEXT_MENU_OPTIONS,
      },
      productItems: [],
      selectedCells: [],
      selectedCellsItem: {},
    };
  },
  components: {
    WarehouseBox,
    InfiniteScroll,
    WarehouseViewDialog,
    ContextMenu,
    ProductListInWarehouse,
    DraggableDialog,
    WarehouseStillageBox,
    WarehouseFileDialog,
  },
  props: {
    data: { type: Object },
    warehouseName: { type: String },
  },
  methods: {
    openWarehouseFileDialog() {
      this.$refs.warehouseFileDialogRef.open(this.data.id, this.selectedCells);
    },
    changeCarriageStatus(carriageId, full) {
      return this.$http.post("carriage/full", { carriageId, full });
    },
    async saveSettings() {
      try {
        this.showLoading();
        await Promise.allSettled(
          this.selectedCells.map((item) => {
            return this.changeCarriageStatus(item.id, item.full);
          })
        );
        this.setSuccess({ text: this.$t("successfullySaved") });
        this.contextMenuOptions = {
          ...DEFAULT_CONTEXT_MENU_OPTIONS,
        };
        this.clearSelectedCells();
        this.settingsDialog = false;
        this.$emit("update");
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    openSettingsDialog() {
      this.contextMenuOptions.isVisible = false;
      this.settingsDialog = true;
    },
    async getNextPageProducts() {
      if (this.contextMenuOptions.page < this.contextMenuOptions.lastPage) {
        const { data: products } = await this.getProducts();
        this.productItems[0].products = [
          ...this.productItems[0].products,
          ...products,
        ];
        this.contextMenuOptions.page++;
      }
    },
    CloseWarehouseViewDialog(item) {
      if (!item) {
        this.selectedCellsItem = {};
        this.selectedCells = [];
      }
    },
    openDialog() {
      let data = {
        warehouseName: this.warehouseName,
        carriages: this.selectedCells,
      };
      this.$refs.openDialogStillage.openDialog(data);
      this.onClosedContextMenu();
    },
    onClosedContextMenu() {
      this.contextMenuOptions = {
        ...DEFAULT_CONTEXT_MENU_OPTIONS,
      };
    },
    onClickContextMenu({ event, item }) {
      if (this.$can(this.$permissions.WAREHOUSE_INCOME)) {
        this.contextMenuOptions = {
          ...DEFAULT_CONTEXT_MENU_OPTIONS,
          isVisible: true,
          position: {
            top: event.clientY,
            left: event.clientX,
          },
        };
        if (!this.selectedCellsItem[item.id]) {
          this.selectedCells.push({
            id: item.id,
            name: item.name,
            full: item.full,
          });
          this.$set(this.selectedCellsItem, item.id, item.id);
        }
      }
    },
    closeProductItemInfoDialog() {
      this.productItems = [];
      this.selectedCells = [];
      this.selectedCellsItem = {};
      this.contextMenuOptions = { ...DEFAULT_CONTEXT_MENU_OPTIONS };
    },
    closeDialog(index) {
      this.productItems[index].dialog = false;
    },
    async getProducts() {
      try {
        const { carriageId, page } = this.contextMenuOptions;
        this.showLoading();
        const {
          data: { data, total },
        } = await this.$http.get("product-item/get-by-carriage-short-info", {
          params: { carriageId, page },
        });
        return {
          data,
          lastPage: makerPagination({ total, limit: 10 }).lastPage,
        };
      } catch (e) {
        this.setResponseError({ error: e });
        return Promise.resolve([]);
      } finally {
        this.clearLoading();
      }
    },
    async boxClickHandler(item, { clientX, clientY, ctrlKey }) {
      if (ctrlKey) {
        if (
          !trueSet(item.full) &&
          this.$can(this.$permissions.WAREHOUSE_INCOME)
        ) {
          if (!this.selectedCellsItem[item.id]) {
            this.selectedCells.push({
              id: item.id,
              name: item.name,
            });
            this.$set(this.selectedCellsItem, item.id, item.id);
          } else {
            this.$set(this.selectedCellsItem, item.id, null);
            this.selectedCells = this.selectedCells.filter(
              (cell) => cell.id !== item.id
            );
          }
        }
      } else {
        this.contextMenuOptions = {
          ...this.contextMenuOptions,
          carriageId: item.id,
          page: 0,
        };
        const { data: products, lastPage } = await this.getProducts();
        this.contextMenuOptions = {
          ...this.contextMenuOptions,
          page: this.contextMenuOptions.page + 1,
          lastPage,
        };
        this.selectedCellsItem = { [item.id]: item.id };
        if (!trueSet(item.full)) {
          this.selectedCells = [
            {
              id: item.id,
              name: item.name,
            },
          ];
        } else {
          this.clearSelectedCells();
        }

        const { height } = this.$vuetify.breakpoint;
        if (height - clientY < 50 * products.length + 100) {
          clientY = height - 150 - 80 * products.length;
        }

        this.productItems = [
          {
            id: item.id,
            name: item.name,
            dialog: true,
            products,
            top: clientY,
            left: clientX,
          },
        ];
      }
    },
    clearSelectedCells() {
      this.selectedCells = [];
      this.selectedCellsItem = {};
    },
  },
  computed: {
    getLetter: () => getLetter,
    trueSet: () => trueSet,
    canIncomeAction() {
      return this.selectedCells.every((item) => {
        return !this.trueSet(item.full);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.show_animation_alarm {
  &::before {
    content: "";
    width: 13px;
    position: absolute;
    height: 13px;
    border-radius: 50%;
    background: red;
    opacity: 0.8;
    right: 5px;
    top: 5px;
    animation: pulse 2s linear infinite;
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(203, 49, 49, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 100px rgba(112, 33, 33, 0.7);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(203, 49, 49, 0.7);
  }
}
</style>
